import React from "react";
import "./styles/styles.css";

const Loader = () => (
  <div className="preloader-image-wrapper">
    <div className="preloader-image"></div>
  </div>
);

export default Loader
